import React from 'react';
import { XCircleIcon } from 'lucide-react';
import { pains } from '../data/content';
export function PainSection() {
  return <section aria-labelledby="pain" className="bg-surface px-5 py-20 sm:py-24" data-id="element-182" data-mp="38xerf3fro5n7">
      <div className="mx-auto max-w-5xl" data-id="element-183" data-mp="2ux405zajop1i">
        <h2 id="pain" className="text-center text-3xl font-black uppercase leading-tight text-white sm:text-5xl" data-id="element-184" data-mp="2v08aleelsh0m">
          ¿Cuántas tardes más vas a <span className="text-coral" data-id="element-185" data-mp="2l7uaeq36bigk">terminar así?</span>
        </h2>

        <div className="mx-auto mt-10 max-w-3xl space-y-5 text-lg leading-relaxed text-cream/90" data-id="element-186" data-mp="2pz2gpd97inpi">
          <p data-id="element-187" data-mp="2ba6c5q6czstn">
            Quieres que tus hijos se diviertan y aprendan, pero cada tarde escuchas <strong className="text-white" data-id="element-188" data-mp="2b83f4m6sgzff">«Estoy aburrido»</strong> y terminan otra vez frente a una pantalla.
          </p>
          <p className="border-l-4 border-brand pl-5 text-xl font-black text-white" data-id="element-189" data-mp="229qc6qotr3tj">
            No es falta de creatividad. Es falta de un sistema listo para usar.
          </p>
        </div>

        <ul className="mt-12 grid gap-x-10 gap-y-1 md:grid-cols-2" data-id="element-190" data-mp="3rn0wrsnft8av">
          {pains.map(p => <li key={p} className="flex gap-4 border-b border-line py-5" data-id="element-191" data-mp="3nlpd03r8vhal">
              <XCircleIcon className="mt-0.5 h-6 w-6 shrink-0 text-coral" aria-hidden="true" data-id="element-192" data-mp="3nni8cmweqf3a" />
              <span className="text-base font-semibold leading-relaxed text-cream" data-id="element-193" data-mp="5dq4wgakpqev">{p}</span>
            </li>)}
        </ul>

        <p className="mt-16 text-center text-2xl font-black uppercase leading-tight text-brand sm:text-4xl" data-id="element-194" data-mp="38w9mmovmldvf">
          ¿Y si esta fuera la última tarde que pasas así?
        </p>
      </div>
    </section>;
}